module.exports = __webpack_public_path__ + "static/black-aa-hero-mobile.04a62021.webp";